import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Sid,  SidDeviationOwner } from './sid.model';
import { Observable } from 'rxjs';
import { TableData, RequestResult } from '../shared/shared.model';
import { API_URL } from '../app.constants';
import { map } from 'rxjs/operators';
import { SidFilter, AuditOwnerGroup } from './audit.model';

@Injectable({
  providedIn: 'root'
})
export class SidService {

  constructor(
    private http: HttpClient
  ) {}

  private sidFilter: SidFilter;

  getSidFilter(): SidFilter {
    return this.sidFilter;
  }

  setSidFilter(f: SidFilter): void {
    this.sidFilter = f;
  }

  list(page: number = 0, pageSize: number = 10, searchKeyword: string = ''): Observable<TableData<Sid>> {
    if (this.sidFilter) {
      return this.http.post<TableData<Sid>>(`${API_URL}/Sid/flt`, this.sidFilter, {
        params: {
          SearchKeyword: searchKeyword,
          Page: (++page).toString(),
          PageSize: pageSize.toString(),
        },
      }).pipe(
        map((res: TableData<Sid>) => {
          res.page--;

          return res;
        })
      );
    } else {
      return this.http.get<TableData<Sid>>(`${API_URL}/Sid`, {
        params: {
          SearchKeyword: searchKeyword,
          Page: (++page).toString(),
          PageSize: pageSize.toString(),
        },
      }).pipe(
        map((res: TableData<Sid>) => {
          res.page--;

          return res;
        })
      );
    }
  }

  listHistory(page: number = 0, pageSize: number = 10, id: number = 0): Observable<TableData<Sid>> {
    
      return this.http.get<TableData<Sid>>(`${API_URL}/Sid/History/${id}`, {
        params: {          
          Page: (++page).toString(),
          PageSize: pageSize.toString(),
        },
      }).pipe(
        map((res: TableData<Sid>) => {
          res.page--;

          return res;
        })
      );    
  }

  get(id: number | string): Observable<Sid> {
    return this.http.get<Sid>(`${API_URL}/Sid/${id}`);
  }

  getDeviationOwners(): Observable<Array<SidDeviationOwner>> {
    return this.http.get<Array<SidDeviationOwner>>(`${API_URL}/Sid/DeviatiationOwners`);
  }
  getAuditOwnerGroups(): Observable<Array<AuditOwnerGroup>> {
    return this.http.get<Array<AuditOwnerGroup>>(`${API_URL}/AuditOwnerGroups/all`);
  }

  create(sid: Sid): Observable<number> {
    return this.http.post<number>(`${API_URL}/Sid`, sid);
  }
  checkTitleExistence(title: string): Observable<boolean> {
    return this.http.get<boolean>(`${API_URL}/Sid/exists/${encodeURI(title)}`);
  }
  update(sid: Sid): Observable<number> {
    return this.http.patch<number>(`${API_URL}/Sid/${sid.id}`, sid);
  }
  
  submitEntireSid(id: number): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/submit`, undefined);
  }
  tagSid(id: number): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/tag`, undefined);
  }
  untagSid(id: number): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/untag`, undefined);
  }
  smeRejectSid(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/smeReject`, {reason});
  }
  smeReturnSid(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/smeReturn`, {reason});
  }
  smeApproveSid(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/smeApprove`, {reason});
  }
  smeApproveSidSkip2nd(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/smeApproveSkip2nd`, {reason});
  }
  lmdhRejectSid(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/lmdhReject`, {reason});
  }
  lmdhReturnSid(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/lmdhReturn`, {reason});
  }
  lmdhApproveSid(id: number, reason: string): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Sid/${id}/lmdhApprove`, {reason});
  }

  exportXls(page: number = 0, pageSize: number = 10, searchKeyword: string = ''): Observable<Blob> {
    return this.http.post(`${API_URL}/Sid/export`, this.sidFilter, {
      params: {
        SearchKeyword: searchKeyword,
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'blob',
    });
  }
}
